import { useTranslation } from "react-i18next";
import { OldValue } from "../../../../helpers/historyHelpers/components/OldValue";
import { NewValue } from "../../../../helpers/historyHelpers/components/NewValue";
import { Label } from "../../../../helpers/historyHelpers/components/Label";
import { renderCompanyResourceLabel, renderSettingsResourceLabel } from "../../../../../../utils/helpers/settings";
import { firstToUpper } from "../../../../../../utils/helpers/string";

const fields = [
    "days",
    "description",
    "calculationGroups",
    "payGroups",
    "manageAbility",
    "locations",
    "companies",
    "isSameDate",
    "repeatEveryYear",
];

const RenderItem = ({ data }) => {
    const { t } = useTranslation();

    const renderValues = (item, data) => {
        const newValue = data?.[item]?.new;
        const oldValue = data?.[item]?.old;

        if (!data) return null;

        switch (item) {
            case "days": {
                return data?.[item]?.map((item, i) => {
                    const newValue = item?.new;
                    const oldValue = item?.old;

                    const formattedNewValue = (
                        <div className="d-flex flex-column">
                            {newValue?.date && (
                                <span>
                                    {t("date")}: {newValue.date}
                                </span>
                            )}
                            {newValue?.dates?.length > 0 && (
                                <div className="d-flex gap-2">
                                    <span>{t("dates")}:</span>
                                    <div className="d-flex flex-column">
                                        {newValue.dates.map((item, i) => (
                                            <span key={i}>{item}</span>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {newValue?.name && (
                                <span>
                                    {t("name")}: {newValue.name}
                                </span>
                            )}
                            {typeof newValue?.repeatEveryYear === "boolean" && (
                                <span>
                                    {t("repeat-every-year")}:{" "}
                                    {newValue.repeatEveryYear ? t("active") : t("inactive")}
                                </span>
                            )}
                            {typeof newValue?.isSameDate === "boolean" && (
                                <span>
                                    {t("is-same-date")}: {newValue.isSameDate ? t("active") : t("inactive")}
                                </span>
                            )}
                        </div>
                    );
                    const formattedOldValue = (
                        <div className="d-flex flex-column">
                            {oldValue?.name && (
                                <span>
                                    {t("name")}: {oldValue.name}
                                </span>
                            )}
                            {oldValue?.date && (
                                <span>
                                    {t("date")}: {oldValue.date}
                                </span>
                            )}
                            {oldValue?.dates?.length > 0 && (
                                <div className="d-flex gap-2">
                                    <span>{t("dates")}:</span>
                                    <div className="d-flex flex-column">
                                        {oldValue.dates.map((item, i) => (
                                            <span key={i}>{item}</span>
                                        ))}
                                    </div>
                                </div>
                            )}
                            {typeof oldValue?.repeatEveryYear === "boolean" && (
                                <span>
                                    {t("repeat-every-year")}:{" "}
                                    {oldValue.repeatEveryYear ? t("active") : t("inactive")}
                                </span>
                            )}
                            {typeof oldValue?.isSameDate === "boolean" && (
                                <span>
                                    {t("is-same-date")}: {oldValue.isSameDate ? t("active") : t("inactive")}
                                </span>
                            )}
                        </div>
                    );

                    return (
                        <div key={i} className="d-flex align-items-center gap-2">
                            <OldValue value={formattedOldValue} />
                            <NewValue value={formattedNewValue} />
                        </div>
                    );
                });
            }
            case "companies": {
                const formattedNewValue = (
                    <div className="d-flex flex-column">
                        {data[item]?.new.map((item) => {
                            return <div key={item}>{renderCompanyResourceLabel(item)}</div>;
                        })}
                    </div>
                );

                const formattedOldValue = (
                    <div className="d-flex flex-column">
                        {data[item]?.old.map((item) => {
                            return <div key={item}>{renderCompanyResourceLabel(item)}</div>;
                        })}
                    </div>
                );

                return (
                    <div className="d-flex align-items-center">
                        <OldValue value={formattedOldValue} />
                        <NewValue value={formattedNewValue} />
                    </div>
                );
            }
            case "status":
            case "description":
            case "manageAbility": {
                return (
                    <div className="d-flex align-items-center">
                        {oldValue && <OldValue value={t(oldValue)} />}
                        {newValue && <NewValue value={t(newValue)} />}
                    </div>
                );
            }
            case "payGroups":
            case "locations":
            case "calculationGroups": {
                const formattedNewValue = (
                    <div className="d-flex flex-column">
                        {data[item]?.new.map((item) => {
                            return <div key={item}>{renderSettingsResourceLabel(item)}</div>;
                        })}
                    </div>
                );

                const formattedOldValue = (
                    <div className="d-flex flex-column">
                        {data[item]?.old.map((item) => {
                            return <div key={item}>{renderSettingsResourceLabel(item)}</div>;
                        })}
                    </div>
                );

                return (
                    <div className="d-flex align-items-center">
                        <OldValue value={formattedOldValue} />
                        <NewValue value={formattedNewValue} />
                    </div>
                );
            }
            default:
                return null;
        }
    };

    return (
        <div className="tooltip-content-style text-left">
            {fields.map((item) => {
                if (!data[item]) return null;

                return (
                    <div key={item} className="py-1 d-flex flex-column gap-2">
                        <Label value={firstToUpper(t(item))} /> {renderValues(item, data)}
                    </div>
                );
            })}
        </div>
    );
};

export default RenderItem;
